import { useSelector } from "react-redux";
import { InputContainer } from "../../../../common/components/form/form.module";
import { useAppDispatch } from "../../../../hooks/hooks";
import { prepares } from "../../../../redux/prepares/action";
import { selectPreparesCreatedItem } from "../../../../redux/prepares/selector";
import { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import { deepCopy } from "../../../../common/services/common.service";
import { campaigns } from "../../../../redux/campaigns/action";
import { selectCampaignsCreatedItem } from "../../../../redux/campaigns/selector";
import { emailCampaigns } from "../../../../redux/email-campaigns/action";
import { selectEmailCampaignsCreatedItem } from "../../../../redux/email-campaigns/selector";
import { useNavigate } from "react-router-dom";
import { associatedCampaignDSAPMapping } from "../../../../redux/associated-campaign-dsap-mappings/action";
import CampaignEmailInfoComponent from "./campaign-email-info.component";

export const PrepareEmailCampaign = ({
    agents,
    choosenCampaign,
    id,
    customerTags,
    campaignFrequency,
    paginationData,
    emailBudget,
    choosenEmailPlan,
    setSelectedTemplate,
    selectedTemplate,
    choosenTemplate,
    closeModal,
    rowData,
    columnDefs,
    setPageData,
    vendorRowData,
    VendorpaginationData,
    vendorColumnDefs
}: any) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [campaign, setCampaign] = useState<any>(choosenCampaign);
    const [emailPlan, setEmailPlan] = useState<any>(choosenEmailPlan);
    const [selectedPlanId, setSelectedPlanId] = useState<any>(null);
    useEffect(() => {
        if (id > 0) {
            setCampaign(choosenCampaign);
        }
    }, [id, choosenCampaign]);
    
    const handlePlanIdChange = (planId: any) => {
        setSelectedPlanId(planId); // assuming setSelectedPlanId is defined using useState
    };
    const handleInnerFormChange: any = (event: any, field: string) => {
        setCampaign({ ...campaign, [field]: event });
    };

    const handlePlanSelect = (data: any) => {
        setEmailPlan(data);
    };

    const close = () => {
        navigate('/partner/campaign')
    };
    
    const handleSubmit = () => {
        const localChoosenCampaign = deepCopy(campaign);
        localChoosenCampaign.EmailPlanId = selectedPlanId;
        localChoosenCampaign.RecipientTagIdInclusions = campaign?.RecipientTagIdInclusions;
        localChoosenCampaign.ReplyToEmailInclusions = [campaign?.ReplyToEmailInclusions];
        localChoosenCampaign.CCTagIdInclusions = campaign?.CCTagIdInclusions;
        localChoosenCampaign.BCCTagIdInclusions = campaign?.BCCTagIdInclusions;

        const updateChoosenCampaign = deepCopy(campaign);
        updateChoosenCampaign.EmailPlanId = selectedPlanId;
        updateChoosenCampaign.RecipientTagIdInclusions = campaign?.RecipientTagIdInclusions;
        updateChoosenCampaign.ReplyToEmailInclusions = campaign?.ReplyToEmailInclusions;
        updateChoosenCampaign.CCTagIdInclusions = campaign?.CCTagIdInclusions;
        updateChoosenCampaign.BCCTagIdInclusions = campaign?.BCCTagIdInclusions;

        const dsapMapping= {
            DSAPId: updateChoosenCampaign?.DSAPId,
            MappedCampaignId: id
        }
        if (id > 0) {
                dispatch(
                    associatedCampaignDSAPMapping.create({
                        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/associated-campaign-dsap-mappings`,
                        entity: "associatedCampaignDSAPMapping",
                        jsonData: {
                            Records: [dsapMapping],
                        },
                    })
                );
              
         
        } else {
            createEmailMarketingCampaign(localChoosenCampaign);
        }
    };

    const handleSubmitNow = () => {
        const localChoosenCampaign = deepCopy(campaign);
        localChoosenCampaign.EmailPlanId =selectedPlanId;
        localChoosenCampaign.RecipientTagIdInclusions = campaign?.RecipientTagIdInclusions;
        localChoosenCampaign.ReplyToEmailInclusions = [campaign?.ReplyToEmailInclusions];
        localChoosenCampaign.CCTagIdInclusions = campaign?.CCTagIdInclusions;
        localChoosenCampaign.BCCTagIdInclusions = campaign?.BCCTagIdInclusions;

        const updateChoosenCampaign = deepCopy(campaign);
        updateChoosenCampaign.EmailPlanId = selectedPlanId;
        updateChoosenCampaign.RecipientTagIdInclusions = campaign?.RecipientTagIdInclusions;
        updateChoosenCampaign.ReplyToEmailInclusions = campaign?.ReplyToEmailInclusions;
        updateChoosenCampaign.CCTagIdInclusions = campaign?.CCTagIdInclusions;
        updateChoosenCampaign.BCCTagIdInclusions = campaign?.BCCTagIdInclusions;

         if (id > 0) {
           
            runEmailMarketingCampaign()
        } else {
            createEmailMarketingCampaign(localChoosenCampaign);
            runEmailMarketingCampaign()
        }
    };

    const createEmailMarketingCampaign = (localChoosenCampaign: any) => {
        dispatch(
            emailCampaigns.create({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/campaign/email-campaigns`,
                entity: "emailCampaigns",
                jsonData: {
                    Records: [localChoosenCampaign],
                },
            })
        );
        navigate("/partner/campaign");
    };


    const runEmailMarketingCampaign = () => {
    
            dispatch(
                emailCampaigns.create({
                    url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/schedule-campaigns/send-campaign`,
                    entity: "emailCampaigns",
                    jsonData: {
                        Records: [{}],
                    },
                })
            );
      
        navigate("/partner/campaign");
    };

    return (
        <div className="flex w-full justify-center items-center">
            <div className="w-full p-2 bg-white shadow-md rounded-md">
                <h1 className="text-xl font-bold mb-4 text-center">
                    {campaign?.Id ? "Edit Campaign" : "Creat Campaign"}
                </h1>
                <div className="flex flex-col gap-4">
                    <CampaignEmailInfoComponent
                        choosenCampaign={campaign}
                        campaignFrequency={campaignFrequency}
                        customerTags={customerTags}
                        choosenEmailPlan={emailPlan}
                        emailBudget={{}}
                        emailNotes={{}}
                        setSelectedTemplate={setSelectedTemplate}
                        selectedTemplate={selectedTemplate}
                        choosenTemplate={choosenTemplate}
                        handlePlanSelect={handlePlanSelect}  
                        handleInnerFormChange={handleInnerFormChange}
                        onPlanIdChange={handlePlanIdChange} // New prop
                        rowData={rowData}
                        columnDefs={columnDefs}
                        setPageData={setPageData}
                        paginationData={paginationData}
                        vendorRowData={vendorRowData}
                        VendorpaginationData={VendorpaginationData}
                        vendorColumnDefs={vendorColumnDefs}
                        agents={agents}
                    />
                </div>
                <div className="text-end">
                    <button
                        onClick={close}
                        type="button"
                        className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
                    >
                        Back
                    </button>
                    <button
                        className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
                        onClick={handleSubmitNow}
                        type="submit"
                    >
                        Schedule Now
                    </button>
                    
                </div>
            </div>
        </div>
    );
};
